import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import './styles/global.css'
import './styles/utilities.css'

function App() {
  return <RouterProvider router={router} />
}

export default App
